import React, { Component } from 'react';
import Footer from "../components/Footer.js"
import NavBar from "../components/NavBar.js"
import MenuCategoryNav from "../components/MenuCategoryNav.js"
import MenuItemCard from "../components/MenuItemCard.js"

import '../css/main.css';
import { fetchMenu } from '../api/menu.js'

class MenuPage extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	cat_list: [],
	    	menu_dict: {}
	    };
	}

	componentDidMount() {
		fetchMenu().then(data => {
			this.setState({
				cat_list: data.cat_list,
				menu_dict: data.menu_dict
			});
		});
	}

  	render() {
	    return (
	        <div id="body">
	          <NavBar />

	          <MenuCategoryNav categories={this.state.cat_list} />

	          <div className="menu_page_header">
	            <div className="section_header">
	              <span className="section_label">Our Menu</span>
	              <h2 className="section_title">豆日子菜單</h2>
	            </div>
	          </div>

	          {this.state.cat_list.map((cat_name, catIndex) => (
	            <section key={catIndex} id={cat_name} style={{
	              background: catIndex % 2 === 0 ? 'var(--bg-base)' : 'var(--bg-recessed)'
	            }}>
	              <h3 className="menu_section_title">{cat_name}</h3>
	              <div className="menu_card_grid">
	                {this.state.menu_dict[cat_name].map((item, i) => (
	                  <MenuItemCard key={i} item={item} category={cat_name} />
	                ))}
	              </div>
	            </section>
	          ))}

	          <Footer />
	        </div>
	    );
	}
}

export default MenuPage;
